module.exports = "/work-site/img/team.3f04e65b.png";